module.exports = __webpack_public_path__ + "TiemposFine-RegularItalic.svg?eb1b093d0173e93f0a203915a223a92c";